// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1p5da","list":"BalanceDue_list__24rRR","listRow":"BalanceDue_listRow__3QdXW","total":"BalanceDue_total__12_CK"};